import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Card from "../../../components/Card";
import { getApiCall, patchApiCall } from "../../../service/httpCall";
import {
  API_NOTIFICATION_SINGLE,
  API_NOTIFICATION_EDIT,
} from "../../../service/url";
import { ROUTES } from "../../../utilities/constant";

const NotificationEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [type, setType] = useState("");
  const [description, setDescription] = useState("");
  const [isGeneral, setIsGeneral] = useState(false);
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({
    type: "",
    description: "",
  });

  useEffect(() => {
    getApiCall(API_NOTIFICATION_SINGLE.replace(":id", id)).then((resp) => {
      const data = resp?.data || resp;
      setType(data.notification_type || "");
      setDescription(data.description || "");
      setIsGeneral(data.is_general || false);
    });
  }, [id]);

  const validate = () => {
    let newErrors = {
      type: "",
      description: "",
    };

    let isValid = true;

    if (!type.trim()) {
      newErrors.type = "Notification Type is required";
      isValid = false;
    }

    if (!description.trim()) {
      newErrors.description = "Description is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const submitForm = () => {
    if (!validate()) return;

    setLoading(true);

    patchApiCall(API_NOTIFICATION_EDIT.replace(":id", id), {
      notification_type: type,
      description,
      is_general: isGeneral
    })
      .then(() => {
        toast.success("Updated!");
        navigate(`/${ROUTES.NOTIFICATION.LIST}`);
      })
      .catch((err) => {
        const errorMsg =
          err?.response?.data?.message || err?.message || "Update unsuccessful";
        toast.error(errorMsg);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Card>
      <Card.Header>
        <h4>Edit Notification</h4>
      </Card.Header>
      <Card.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>
              Title <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              value={type}
              onChange={(e) => {
                setType(e.target.value);
                setErrors((prev) => ({ ...prev, type: "" }));
              }}
              isInvalid={!!errors.type}
            />
            <Form.Control.Feedback type="invalid">
              {errors.type}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Description <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                setErrors((prev) => ({ ...prev, description: "" }));
              }}
              isInvalid={!!errors.description}
            />
            <Form.Control.Feedback type="invalid">
              {errors.description}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Check 
              type="checkbox"
              id="is-general-edit"
              label="Is General Notification"
              checked={isGeneral}
              onChange={(e) => setIsGeneral(e.target.checked)}
            />
          </Form.Group>

          <Button onClick={submitForm} disabled={loading}>
            {loading ? "Updating..." : "Update"}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default NotificationEdit;